/** A safe, stable Error message survives Router error dehydration. */
export const documentForbiddenMessage = 'You are not allowed to view this page.'
